import { Injectable, OnDestroy } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router,
} from '@angular/router';
import { AuthFacade } from '@tvt-logistics-india/data-access';
import { Auth } from 'aws-amplify';
import { from, Observable, Subscription } from 'rxjs';
import { map, takeWhile } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class EmployeeValidatorGuard implements CanActivate {
  sessionSubscription: Subscription;
  constructor(public router: Router, public authFacade: AuthFacade) {}
  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean> {
    this.authFacade.loadAll();
    return from(Auth.currentSession()).pipe(
      takeWhile((data) => !data, true),
      map((data: any) => {
        const validUser = data?.isValid();
        const group = data?.accessToken.payload['cognito:groups'][0];

        if (validUser) {
          return true;
        } else {
          this.router.navigate(['/sign-in']);
          return false;
        }
      })
    );
  }
}
